import React from 'react';
import { Container, Theme, useMediaQuery } from '@mui/material';
import { Button, EmptyState, useI18nContext } from '@procore/core-react';
import { DEFAULT_COUNTRY } from '../../data/location/countries';
import { getStateList } from '../../data/location/states';
import routes from '../../helpers/routes';
import { TopStatesResult } from '../../services/states';
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import LinkList from '../Layout/LinkList';
import { useStyles } from './LocationError.styles';

interface LocationErrorProps {
  promptRetry?: boolean;
  states?: TopStatesResult[];
  title: string;
  message: string;
}

const LocationError = (props: LocationErrorProps) => {
  const I18n = useI18nContext();
  const classes = useStyles();

  const smallScreen = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('md')
  );

  const onRetry = () => {
    window.location.reload();
  };

  return (
    <div className={classes.pageContainer}>
      <Header />
      <EmptyState className={classes.emptyContainer} compact={smallScreen}>
        <EmptyState.NoResults />
        <EmptyState.Title>{props.title}</EmptyState.Title>
        <EmptyState.Description>{props.message}</EmptyState.Description>
        {props.promptRetry && (
          <EmptyState.Actions>
            <Button variant="secondary" onClick={onRetry}>
              {I18n.t('components.location_error.retry')}
            </Button>
          </EmptyState.Actions>
        )}
      </EmptyState>
      {props.states && (
        <Container className={classes.linkedListContainer}>
          <LinkList
            title={`Construction Professionals in ${DEFAULT_COUNTRY.name} by State`}
            links={getStateList(DEFAULT_COUNTRY)
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((state) => {
                const count = props.states
                  .find((result) => result.state === state.abbreviation)
                  ?.count?.toLocaleString();
                return {
                  label: `Contractors in ${state.name} (${count || 0})`,
                  href: routes.location(
                    DEFAULT_COUNTRY.alpha2,
                    state.abbreviation
                  ),
                };
              })}
            headerElement="h2"
            canViewMore={false}
          />
        </Container>
      )}
      <Footer showDiscover={false} />
    </div>
  );
};

export default LocationError;
